/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoomPlanningCalendarResourceSchema } from '../models/RoomPlanningCalendarResourceSchema';
import type { TimelineEventSchema } from '../models/TimelineEventSchema';
import type { VisitStatus } from '../models/VisitStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CalendarRoomPlanningApi {
    /**
     * Get Room Planning Resources
     * Get resources for room planning
     * @returns RoomPlanningCalendarResourceSchema OK
     * @throws ApiError
     */
    public static calendarGetRoomPlanningResourcesGet(): CancelablePromise<RoomPlanningCalendarResourceSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar-room-planning/resources/',
        });
    }
    /**
     * Get Room Planning Event List
     * Get events for rooms planning
     * @returns TimelineEventSchema OK
     * @throws ApiError
     */
    public static calendarGetRoomPlanningEventListGet({
        start,
        end,
        statuses,
    }: {
        /**
         * When to start filtering.
         */
        start: string,
        /**
         * When to end filtering.
         */
        end: string,
        /**
         * Only return visits in these statuses. Omit for all statuses.
         */
        statuses?: (Array<VisitStatus> | null),
    }): CancelablePromise<Array<TimelineEventSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/calendar-room-planning/events/',
            query: {
                'start': start,
                'end': end,
                'statuses': statuses,
            },
        });
    }
}
